import gql from 'graphql-tag'

export const GET_PAPERS = gql`
  query GetPapers(
    $orderBy: PapersOrderBy = updatedAt
    $order: Order = desc
    $limit: Int!
    $page: Int = 1
  ) {
    getPapers(orderBy: $orderBy, order: $order, limit: $limit, page: $page) {
      uploadUuid
      filename
      updatedAt
    }
  }
`
